import { supabase } from "./db_connection";

// 1. Fetch All Posts (Announcements, Links, Holidays)
export async function getDashboardData() {
    const { data, error } = await supabase
        .from('dashboard_posts')
        .select('*')
        .order('created_at', { ascending: false });
    return { data, error };
}

// 2. Fetch Birthdays (From Profiles)
// export async function getTodaysBirthdays() {
//     const today = new Date();
//     const month = today.getMonth() + 1; // 1-12
//     const day = today.getDate();

//     // Note: Supabase me extract function se date match karna thoda complex hota hai
//     // Isliye hum sab fetch karke filter karenge (Agar user base chhota hai)
//     const { data, error } = await supabase
//         .from('profiles')
//         .select('first_name, last_name, dob');

//     if (error) return { error };

//     const birthdays = data.filter(user => {
//         if (!user.dob) return false;
//         const dob = new Date(user.dob);
//         return dob.getMonth() + 1 === month && dob.getDate() === day;
//     });

//     return { data: birthdays };
// }
// All birthdays fetch
export const getAllBirthdays = async () => {
  const { data, error } = await supabase
    .from("profiles")
    .select("id, first_name, last_name, dob")
    .not("dob", "is", null);

  if (error) {
    console.error("Birthday fetch error:", error);
    return { data: [] };
  }

  const today = new Date();
  today.setHours(0, 0, 0, 0); // important

  const sortedBirthdays = data.sort((a, b) => {
    const aDob = new Date(a.dob);
    const bDob = new Date(b.dob);

    const aNext = new Date(today.getFullYear(), aDob.getMonth(), aDob.getDate());
    const bNext = new Date(today.getFullYear(), bDob.getMonth(), bDob.getDate());

    if (aNext < today) aNext.setFullYear(today.getFullYear() + 1);
    if (bNext < today) bNext.setFullYear(today.getFullYear() + 1);

    return aNext - bNext;
  });

  return { data: sortedBirthdays };
};

// 3. Add New Post (Admin Use)
export async function addDashboardPost(postData) {
    const { data, error } = await supabase
        .from('dashboard_posts')
        .insert([postData])
        .select()
        .single();
    return { data, error };
}